import api, { formatApiError } from "../../lib/api";

export const inp = "w-full border border-mist rounded-sm px-3 py-2 bg-white text-base md:text-sm focus:outline-none focus:border-sage-dark";
export const btnPrimary = "inline-flex items-center justify-center gap-1.5 bg-sage-dark text-white px-4 py-2.5 rounded-sm text-xs uppercase tracking-widest hover:bg-sage-deep disabled:opacity-50 transition-colors";
export const btnGhost = "inline-flex items-center justify-center gap-1.5 border border-mist bg-white px-4 py-2.5 rounded-sm text-xs uppercase tracking-widest text-ink hover:border-sage-dark disabled:opacity-50 transition-colors";

export const fmtIDR = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export const COUNTRY_ID = { Japan: "Jepang", China: "Tiongkok", Singapore: "Singapura", USA: "Amerika Serikat", Europe: "Eropa", Other: "Lainnya" };
export const countryLabel = (c) => COUNTRY_ID[c] || c;

export const CHECK_ID = {
    MATCHED: "COCOK", MISMATCH: "TIDAK COCOK", WAITING: "MENUNGGU", PENDING_SOURCE: "MENUNGGU DATA SUMBER", SOURCE_UNAVAILABLE: "DATA SUMBER TIDAK TERSEDIA",
    "MISMATCH — PLEASE RECHECK": "TIDAK COCOK — MOHON CEK ULANG", "WAITING FOR OTHER REPORT": "MENUNGGU LAPORAN LAIN", "PENDING SOURCE DATA": "MENUNGGU DATA SUMBER",
};
export const checkLabel = (s) => CHECK_ID[s || "WAITING"] || s;

export const todayWIB = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());

export const fmtDateTimeWIB = (iso) =>
    iso
        ? new Intl.DateTimeFormat("id-ID", {
              timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
          }).format(new Date(iso)) + " WIB"
        : "—";

export async function apiError(err) {
    const data = err?.response?.data;
    if (data instanceof Blob) {
        try {
            return formatApiError(JSON.parse(await data.text()).detail);
        } catch {
            return "Permintaan gagal";
        }
    }
    return formatApiError(data?.detail);
}

export async function downloadFile(url, params, fallbackName) {
    const res = await api.get(url, { params, responseType: "blob" });
    const cd = res.headers["content-disposition"] || "";
    const m = cd.match(/filename="([^"]+)"/);
    const href = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = m ? m[1] : fallbackName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);
}
